export default __webpack_public_path__ + "static/media/cohort-play.bfa9f79f.svg";